import { render, staticRenderFns } from "./advertNotice.vue?vue&type=template&id=9e376a46&scoped=true"
import script from "./advertNotice.vue?vue&type=script&lang=js"
export * from "./advertNotice.vue?vue&type=script&lang=js"
import style0 from "./advertNotice.vue?vue&type=style&index=0&id=9e376a46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e376a46",
  null
  
)

export default component.exports